import { html } from '../../utils/lit/html.js';
import OCLogoUSDark from '../../shared/assets/icons/oddschecker-logo-us-dark.png';

const styles = html`<style>
  .footer {
    user-select: none;
    -webkit-user-select: none;
    background: var(--disclaimer-background, #ccc);
    border: var(--disclaimer-border, 0);
    border-radius: var(--disclaimer-border-radius, 0);
    color: var(--disclaimer-color, #000);
    padding: var(--disclaimer-padding, 10px);
    font-family: var(--disclaimer-font-family, inherit);
    font-size: var(--disclaimer-font-size, 13px);

    .notice {
      user-select: text;
      -webkit-user-select: text;
    }

    .notice:not(:empty) + .icons {
      margin-top: 16px;
    }

    .icons {
      display: flex;
      justify-content: space-between;
    }

    .icons > :not(.poweredby) {
      display: flex;
      flex-wrap: wrap;
      align-items: end;
      gap: 8px;
    }

    .poweredby {
      display: flex;
      align-items: end;
      gap: 10px;
    }

    .icons img {
      height: 20px;
    }

    .poweredby:only-child {
      margin-left: auto;
    }
  }
</style> `;

export type DisclaimerPayload = {
  notice?: string;
  icons?: string;
  poweredby?: boolean;
};

export default function DisclaimerTemplate({
  notice,
  icons,
  poweredby
}: DisclaimerPayload) {
  return html` ${styles}
    <footer class="footer">
      ${notice ? html`<div class="notice">${notice}</div>` : ''}

      <div class="icons">
        ${icons ? html`<div>${icons}</div>` : ''}
        ${
          poweredby
            ? `<div class="poweredby">
          <span>Powered by</span>
          <img src="${OCLogoUSDark}" alt="Oddschecker Logo" height="20" />
        </div>`
            : ''
        }
      </div>
    </footer>`;
}
